import { useRef } from 'react';
import { Button, CenterScreenModal } from '../atoms'
import { 
  useAddContactFormModalContext,
  useErrorHandlerContext,
  useOpeningElementsControllerContext,
  usePropertyDetailContext,
  useUserLanguage,
} from '@/customHooks'
import { Col, Row } from 'react-grid-system';
import {
  CreateContactInput,
  useCreateContactFromPropertyMutation,
  useUpdateContactFromPropertyMutation,
} from '@/graphql/generated';
import { AddContactFormControlled } from '../organism';

const textsData = {
  en: {
    title: 'Add a Contact',
    confirmation: {
      create: {
        title: 'Contact has been created',
        description: (name: string) => `Contact ${name} has been created succesfully`,
      },
      update: {
        title: 'Contact has been updated',
        description: (name: string) => `Contact ${name} has been updated succesfully`,
      },
    },
    button: {
      confirm: 'Confirm',
      cancel: 'Cancel'
    }
  },
  es: {
    title: 'Agregar un Contacto',
    confirmation: {
      create: {
        title: 'Contacto creado con éxito',
        description: (name: string) => `El contacto ${name} fue creado con éxito`,
      },
      update: {
        title: 'Contacto actualizado con exito',
        description: (name: string) => `El contacto ${name} fue actualizado con éxito`,
      },
    },
    button: {
      confirm: 'Aceptar',
      cancel: 'Volver'
    }
  }
}

export const AddContactFormModal = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const contactDataRef = useRef<CreateContactInput | null>(null)
  
  const [createContact, { loading: createLoading }] = useCreateContactFromPropertyMutation()
  const [updateContact, { loading: updateLoading }] = useUpdateContactFromPropertyMutation()

  const { confirmDialogModalOpen } = useOpeningElementsControllerContext()

  const { contactData, isOpen, closeModal } = useAddContactFormModalContext()

  const { property, setProperty } = usePropertyDetailContext()
  
  const { open } = useErrorHandlerContext()

  const OnChangeHandle = (data: CreateContactInput) => {
    contactDataRef.current = data
  }

  const onConfirmHandle = () => {
    if (!contactDataRef.current) return
    
    if (contactData === null) {
      createContact({ variables: {
        propertyId: property?.id ?? '',
        contactInput: contactDataRef.current,
      }})
      .then((response) => {
        setProperty(undefined)
        closeModal()
        confirmDialogModalOpen({
          title: texts.confirmation.create.title,
          description: texts.confirmation.create.description(`${response.data?.createContactFromProperty.firstName} ${response.data?.createContactFromProperty.lastName}`),
        })
      })
      .catch((error) => {
        closeModal()
        open(error)
      })
    } 
    else {

      updateContact({ variables: {
        propertyId: property?.id ?? '',
        contactId: contactData.id,
        contactInput: contactDataRef.current,
      }})
      .then((response) => {
        setProperty(undefined)
        closeModal()
        confirmDialogModalOpen({
          title: texts.confirmation.update.title,
          description: texts.confirmation.update.description(`${response.data?.updateContactFromProperty.firstName} ${response.data?.updateContactFromProperty.lastName}`)
        })
      })
      .catch((error) => {
        closeModal()
        open(error)
      })  
    }

  }
  
  return (
    <CenterScreenModal
      isOpen={isOpen}
      onClose={closeModal}
    >
      <Row>
        <Col>
          <h2>{texts.title}</h2>
        </Col>
      </Row>
      <AddContactFormControlled
        defaultData={
          contactData
          ? contactData : undefined
        }
        onChange={OnChangeHandle}
      />
      <br />
      <Row justify="center" gutterWidth={32}>
        <Col xs="content">
          <Button secondary onClick={() => closeModal()} disabled={!!updateLoading || !!createLoading}>
            {texts.button.cancel}
          </Button>
        </Col>
        <Col xs="content">
          <Button
            onClick={() => onConfirmHandle()}
            isLoading={!!updateLoading || !!createLoading}
          >
            {texts.button.confirm}
          </Button>
        </Col>
      </Row>
    </CenterScreenModal>
  )
}
